export const devTeam = [
  "p.chopin@qivia.fr",
  "m.gatinois@qivia.fr",
  "t.bouffard@qivia.fr",
  "a.em@qivia.fr",
];
